module.exports = __webpack_public_path__ + "img/pic_start_supersale2@2x.fe0aff35.png";